<template>
    <div :class="`empty-box ${size ? 'empty-' + size : ''}`">
        <div v-if="show">
            <slot></slot>
        </div>
        <div class="empty-body" v-else>
            <div class="empty-img" v-if="icon">
                <img :src="icon">
            </div>
            <div class="empty-text">
                {{message}}
                <slot name="message"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        icon: {
            type: String,
            default: () => {
                return require('@/assets/imgs/icon-empty-gray.png')
            }
        },
        /**
         * 尺寸
         * large 大
         * medium 中
         * small 小
         * mini 迷你
         */
        size: {
            type: String,
            default: 'medium'
        },
        show: {
            type: Boolean,
            default: true
        },
        message: {
            type: String,
            default: '暂无数据~'
        }
    }
}
</script>


<style lang="scss" scoped>
.empty-box {
    overflow: hidden;
    .empty-body {
        padding-top: 48px;
        padding-bottom: 84px;
        text-align: center;
        .empty-img {
            font-size: 0;
            overflow: hidden;
            margin: 0 auto;
            text-align: center;
            img {
                max-width: 100%;
                max-height: 100%;
                min-width: 100%;
                min-height: 100%;
                display: inline-block;
                vertical-align: middle;
                opacity: 0.5;
            }
        }
        .empty-text {
            color: #b4b4b4;
            margin-top: 24px;
        }
    }
    &.empty-large {
        .empty-body {
            .empty-img {
                width: 180px;
                height: 180px;
                line-height: 180px;
            }
        }
    }
    &.empty-medium {
        .empty-body {
            .empty-img {
                width: 160px;
                height: 160px;
                line-height: 160px;
            }
        }
    }
    &.empty-small {
        .empty-body {
            .empty-img {
                width: 120px;
                height: 120px;
                line-height: 120px;
            }
        }
    }
    &.empty-mini {
        .empty-body {
            .empty-img {
                width: 60px;
                height: 60px;
                line-height: 60px;
            }
        }
    }
}
</style>
